import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {API_URL} from '../../../constants';
import {updateValueInJson, hideModalPageClass, showModalPageClass, validateAccesoGeneral, getRoles, esUrl} from '../../../functions';
import axios from 'axios';
import $ from 'jquery';
import ModalPaginas from '../../Partials/ModalPaginas';

export default class AgregarProgramaCapacitacion extends Component {

    constructor(props) {

        super(props);

        this.state = {
            tituloLongitud:0,
            descripcionLongitud:0,
            resource: {
                pcap_Titulo:"",
                pcap_Descripcion:"",
                pcap_Enlace:"",
                sect_Id:0,
                pweb_Id:0,
                chan_Id:0,
                pcap_Orden:this.props.location.state !== undefined ? this.props.location.state.totalRegistros + 1 : "",
                pcap_Activo:true
            },
            Validacion: {
                pcap_Titulo: {
                    Error: false,
                },
                pcap_Descripcion: {
                    Error: false,
                },
                pcap_Enlace: {
                    Error: false,
                },
                sect_Id: {
                    Error: false,
                },
                pweb_Id: {
                    Error: false,
                },
                chan_Id: {
                    Error: false,
                },
                pcap_Orden: {
                    Error: false,
                }
            },
            categorias: [],
            sectores: [],
            perfiles: [],
            hasError:false,
            hasErrorProceso:false,
            added: false,
            security: cookie.load('user'),
            roles: [],
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getResponse = this.getResponse.bind(this);

      }

    getResponse = (urlSeleccionada) => {
        let resource = this.state.resource;
        resource.pcap_Enlace = urlSeleccionada;

        this.setState({resource:resource});

        hideModalPageClass();
    }

    handleClickCancel(e) {

        e.preventDefault();

        const {history: {push}} = this.props;
        push('/programas-capacitacion');
     }

     callFunctionButton = (event) => {

        event.preventDefault();

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.pcap_Titulo == '') {
            newState.Validacion.pcap_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.pcap_Descripcion == '') {
            newState.Validacion.pcap_Descripcion = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.pcap_Enlace == '' || !esUrl(newState.resource.pcap_Enlace))
		{
            newState.Validacion.pcap_Enlace = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.chan_Id == 0) {
            newState.Validacion.chan_Id = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.pcap_Orden == '') {
            newState.Validacion.pcap_Orden = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ProgramaCapacitacionUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'pcap_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url,
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {

            if (data.data.isSucess)
            {

                let stateResponse = this.state;

                stateResponse.added = true;
                stateResponse.resource.pcap_Titulo = '';
                stateResponse.resource.pcap_Descripcion = '';
                stateResponse.resource.pcap_Enlace = '';
                stateResponse.resource.sect_Id = 0;
                stateResponse.resource.pweb_Id = 0;
                stateResponse.resource.chan_Id = 0;
                stateResponse.resource.pcap_Orden += 1 ;
                document.getElementById("sect_Id").selectedIndex = 0;
                document.getElementById("pweb_Id").selectedIndex = 0;
                document.getElementById("chan_Id").selectedIndex = 0;
                this.setState(stateResponse);

                setTimeout(() => {
                    this.setState({added:false});
                }, 3000);

            } else
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => {
                    this.setState({hasErrorProceso:false});
                }, 3000);
            }
        }
        ).catch((error)=> {
        toast.error('Error no controlado.');
        this.setState({loading:false});
        });
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;
        let descripcionLongitud = this.state.descripcionLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,
        }

        if(target.name == 'pcap_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'pcap_Descripcion'){
            descripcionLongitud = value.length;
        }
        this.setState({
            resource: copyResource,
            tituloLongitud: tituloLongitud,
            descripcionLongitud: descripcionLongitud,
            Validacion: validaciones
        });
    }

    componentDidMount()
    {
        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/programas-capacitacion";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol);

        const url = `${API_URL}ProgramaCapacitacionUX/Recursos`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            if(data.statusCode == 200){
                this.setState({
                    categorias: data.result.categorias,
                    sectores: data.result.sectores,
                    perfiles: data.result.perfiles
                });
            }
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    render() {
        return (
            <div class="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de Configuración General
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Agregar Programa de Capacitación</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Agregar Programa de Capacitación
                </div>

                {
                    this.state.hasErrorProceso ?
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar el registro.</div>
                        </div>
                    </div> : null
                }

                {
                    this.state.added ?
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se realizó el registro correctamente.</div>
                        </div>
                    </div>: null
                }

                <div className="div_Modulos_Noticias">
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Título" name='pcap_Titulo' value={this.state.resource.pcap_Titulo} maxLength={35} className={this.state.Validacion.pcap_Titulo.Error ? "error" : ""}
                        onChange={this.handleInputChange}/>
                        <span data-length={35}>{this.state.tituloLongitud}/35</span>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Descripción" name='pcap_Descripcion' value={this.state.resource.pcap_Descripcion} maxLength={250} className={this.state.Validacion.pcap_Descripcion.Error ? "error" : ""}
                        onChange={this.handleInputChange}/>
                        <span data-length={250}>{this.state.descripcionLongitud}/250</span>
                    </div>

                    <div className="txtFile x-1">
                        <span className="openLink" onClick={() => showModalPageClass()}/>
                        <input type="text" placeholder="Enlace" name='pcap_Enlace' value={this.state.resource.pcap_Enlace} className={this.state.Validacion.pcap_Enlace.Error ? "error" : ""}
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <select name='chan_Id' id='chan_Id' onChange={this.handleInputChange} className={this.state.Validacion.chan_Id.Error ? "error" : ""}>
                            <option value="0">Seleccionar Categoría</option>
                            {
                                this.state.categorias.length > 0 ?
                                this.state.categorias.map((categoria) => (
                                    <option value={categoria.id}>{categoria.nombre.toUpperCase()}</option>
                                ))
                                : null
                            }
                        </select>
                    </div>

                    <div className="txtFile x-1">
                        <select name='sect_Id' id='sect_Id' onChange={this.handleInputChange}>
                            <option value="0">Seleccionar Sector</option>
                            {
                                this.state.sectores.length > 0 ?
                                this.state.sectores.map((sector) => (
                                    <option value={sector.id}>{sector.nombre.toUpperCase()}</option>
                                ))
                                : null
                            }
                        </select>
                    </div>

                    <div className="txtFile x-1">
                        <select name='pweb_Id' id='pweb_Id' onChange={this.handleInputChange}>
                            <option value="0">Seleccionar Perfil</option>
                            {
                                this.state.perfiles.length > 0 ?
                                this.state.perfiles.map((perfil) => (
                                    <option value={perfil.id}>{perfil.nombre.toUpperCase()}</option>
                                ))
                                : null
                            }
                        </select>
                    </div>

                    <div className="txtFile x-2">
                        <input type="text" placeholder="Orden" name='pcap_Orden' value={this.state.resource.pcap_Orden} maxLength={2} className={this.state.Validacion.pcap_Orden.Error ? "error" : ""} onChange={this.handleInputChange} onChange={this.handleInputChange}/>
                    </div>

                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />
                <ModalPaginas class={""} callback={this.getResponse.bind(this)} />
            </div>
        )
    }
}